module.exports = __webpack_public_path__ + "img/spirit_big_1.d295cd75.png";